import * as types from "../types/orderForEditDetails"

const initialState = null

const orderForEditDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_ORDER_FOR_EDIT_DETAILS:
      return action.orderForEditDetails
    case types.DELETE_ORDER_FOR_EDIT_DETAILS:
      return null
    default:
      return state
  }
}

export default orderForEditDetailsReducer